const useGetHostName = () => {
  let hostname: string | undefined;

  if (typeof window !== 'undefined') {
    hostname = window.location.origin;
  }

  return [hostname];
};

export default useGetHostName;
